// extracted by mini-css-extract-plugin
export default {"pages":"payment-pages_pages--BQZv6","loader":"payment-pages_loader--lwr3W","previewActions":"payment-pages_previewActions--x6mUj"};